import { put, takeLatest, all, select, call } from 'redux-saga/effects';
import { getCartInfoFIOSBDVmock, getFloatCartFIOSBDVmock , getFloatCartFIOSTVmock } from './constants';

import * as selectors from '../containers/selectors';

export function* loadFloatingCart() {
    
    // TODO: Make API calls or take the response from state, REMOVE AFTER DEV

    //const response = yield apiClient.post(GET_CART_INFO_URL, params, HeadersForFormData);
    //const response = yield apiClient.post(GET_FLOAT_CART_URL, undefined, HeadersForFormData);

    // const cartInfoResponse = getCartInfoFIOSBDVmock;
    // const floatCartResponse = getFloatCartFIOSBDVmock;
    // const floatCartResponse = getFloatCartFIOSTVmock;

    const cartInfoResponse = yield select(selectors.getCartInfoSuccessResponse);
    const floatCartResponse = yield select(selectors.getFloatCartResponse);

    const cartHeader = floatCartResponse?.HeaderInfo;

    let DisplayName = "";
    let internetDisplayName = "";
    let phoneDisplayName = "";
    let tvDisplayName = "";
    if(cartHeader) {
        yield put({ type: "UPDATE_CART_HEADER_SECTION", data: cartHeader });
    }
    let internetSubTotal = 0;
    let phoneSubTotal = 0;
    let tvSubTotal = 0;
    let subTotal = 0;
    if (floatCartResponse) {
        internetSubTotal = floatCartResponse?.DataInfo?.DataPlans ? floatCartResponse?.DataInfo?.DataPlans.reduce((accumulator, plan) => {
            return accumulator + parseFloat(plan.Price);
        }, 0.0) : 0.0;
        const faxline = floatCartResponse?.PhoneInfo?.FaxLine;
        const listingInfo = floatCartResponse?.PhoneInfo?.accountLevel;

        const faxlinePrice = faxline? faxline.reduce((accumulator, plan) => {
            return accumulator + parseFloat(plan.Price);
        }, 0.0) : 0.0;

        const listingInfoPrice = listingInfo? listingInfo.reduce((accumulator, plan) => {
            return accumulator + parseFloat(plan.Price);
        }, 0.0) : 0.0;
        phoneSubTotal = faxlinePrice + listingInfoPrice;
        tvSubTotal = floatCartResponse.TVInfo?.TVPlans ? floatCartResponse.TVInfo?.TVPlans.reduce((accumulator, plan) => {
            return accumulator + parseFloat(plan.Price);
        }, 0.0) : 0.0;
        subTotal = internetSubTotal + phoneSubTotal + tvSubTotal;
    }
    
    /*if(cartHeader.DataTitle) {
        internetDisplayName = "Internet";
        const internetSection = floatCartResponse?.DataInfo;
        internetSection.title = cartHeader.DataTitle;
        yield put({ type: "UPDATE_INTERNET_SECTION", data: internetSection });
    }

    if(cartHeader.PhoneTitle || cartHeader.phoneTitle || (cartHeader.Title && cartHeader.Title.toLowerCase().includes("preferred"))) {
        phoneDisplayName = " Phone";
        const phoneSection = floatCartResponse?.PhoneInfo;
        phoneSection.title = cartHeader.PhoneTitle || cartHeader.Title || cartHeader.phoneTitle;
        yield put({ type: "UPDATE_PHONE_SECTION", data: phoneSection });
    }

    if(cartHeader.TvTitle) {
        tvDisplayName = "TV";
        const tvSection = floatCartResponse?.TVInfo;
        tvSection.title = cartHeader.TvTitle;
        yield put({ type: "UPDATE_TV_SECTION", data: tvSection });
    }

    DisplayName = internetDisplayName + phoneDisplayName + tvDisplayName;

    if(cartHeader) {
        cartHeader.DisplayName = DisplayName;
        yield put({ type: "UPDATE_CART_HEADER_SECTION", data: cartHeader });
    }

    if(cartInfoResponse) {
        yield put({ type: "TOGGLE_IS_API_RESPONSE" , data: true })

        const oneTimeCharges = cartInfoResponse.filter((item) => item.Fmonth);
        
        if(oneTimeCharges && oneTimeCharges[0] && oneTimeCharges[0].Fmonth) {
            yield put({ type: "UPDATE_ONE_TIME_CHARGES_SECTION", data: oneTimeCharges[0].Fmonth });
        }*/

        /*  TODO: FIND OUT OTHER TAX AMOUNT THAT NEEDS TO BE ADDED */
       /* const taxObject = cartInfoResponse.filter((item) => item.fbilltax);

        if(taxObject && taxObject[0] && taxObject[0].fbilltax) {
            yield put({ type: "UPDATE_TAX_SECTION", data: taxObject[0].fbilltax });
        }*/
        
        /*  TODO: CALCULATE UPCOMING MONTHLY CHARGES HERE */
       /* const upcomingCharges = cartInfoResponse.filter((item) => item.Fmonth)[0];
        
        const upcomingMonthlyCharges = {
            "Month 1": subTotal + getOneTimeCharges(upcomingCharges.Fmonth),
            "Months 2": subTotal + getOneTimeCharges(upcomingCharges.Smonth),
            "Months 3": subTotal + getOneTimeCharges(upcomingCharges.Tmonth),
            "Months 4-11": subTotal + getOneTimeCharges(upcomingCharges.four211)
        }
        yield put({ type: "UPDATE_UPCOMING_MONTHS_SECTION", data: upcomingMonthlyCharges });
    }*/
}

function getOneTimeCharges(oneTimeCharges) {
    return oneTimeCharges? oneTimeCharges.reduce((accumulator, offer) => {
    return accumulator + parseFloat(offer.price);
  }, 0.0) : 0.0;
}

export function* dynamicCartActionWatcher() {
    /* THIS IS NO LONGER USED */
   // yield takeLatest('LOAD_FLOATING_CART', loadFloatingCart);
}